<a  *ngIf="isDemoUser">
  <mat-icon aria-hidden="false" aria-label="icon">check</mat-icon>
</a>

